<template>
  <button
    type="button"
    class="player-btn"
    @mousedown="stopEvent"
    @click="doClick"
    :class="[size?size:'m']"
  >
    <img :src="isPlaying?$_getIcon('icons8-pause-24.png'):$_getIcon('icons8-play-24.png')">
  </button>
</template>

<script>
export default {
  name: "g-play-btn",
  props: ["isPlaying", "size"],
  data() {
    return {};
  },
  methods: {
    stopEvent(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.cancelBubble = true;
    },
    doClick(evt) {
      this.stopEvent(evt);
      this.$emit("click");
    }
  }
};
</script>
 
<style lang="scss" scoped>
.player-btn {
  cursor: pointer;
  &.m {
    width: 20px;
    height: 20px;
  }
  &.l {
    width: 32px;
    height: 32px;
    border: 1px solid $gray2;
  }
  @extend .ksm-flex-xy-center;
  padding: 0;
  border: 0;
  img {
    width: 80%;
    height: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// PlayButton.vue?f6f66cd2